// import {GoogleLoginButton} from 'react-social-login-buttons'
// import {LoginSocialGoogle,LoginSocialFacebook} from 'reactjs-social-login'
// import axios from 'axios'
// import { useToast } from '@chakra-ui/react';
// import {useNavigate} from 'react-router-dom'
// import GoogleButton from 'react-google-button'
// import { useCookies } from 'react-cookie';
// import { color } from 'framer-motion';

//  function Facebook(){
//   const [cookies, setCookie] = useCookies();
//   const navigate=useNavigate()

//     const toast = useToast();

//     async function addGoogle(paylaodofGoogle,email){
//       console.log(email,"usermail")

//         try {
          
//           let res1=await axios.post("http://localhost:8001/exist",{email})
//           console.log(res1)
//           // setexistemail(existRes.data)
//           console.log(res1.data)
//           // console.log(existemail, "existemail")
//           if(res1.data==="Email Not Exist"){
//             let res = await axios.post("http://localhost:8001/register", paylaodofGoogle);
//             console.log("google data added")
//             setCookie('email', email);
//             toast({
//               title:"Register with google done",
//               position: "top-right",
//               isClosable: true,
//               status: 'success'
//             })
            
//             navigate("/")
//           //   },2500)
            
//           }else{
//             toast({
//               title:"This Email is Already Used",
//               position: "top-right",
//               isClosable: true,
//               status: 'error'
//             })

//           }

           
            
//         } catch (error) {
//           toast({
//             title:"facing issue sing up with google",
//             position: "top-right",
//             isClosable: true,
//             status: 'error'
//           })
//         //   },2500)
//             console.log(error)
            
//         }


   

//     }



//     return (
//       <>
//         <LoginSocialFacebook
//          appId="2084915091853699"
//           scope="openid profile email"
//           discoveryDocs="claims_supported"
//           access_type="offline"
//         //   onResolve={({ provider, data }) => {
//         //     console.log(provider, data, "data");
//         //     let payload = {
//         //       firstname: data.given_name,
//         //       lastname: data.family_name,
//         //       email: data.email,
//         //       password: `${data.given_name}1234`,
//         //     };

//         //     addGoogle(payload, payload.email);
//         onResolve={({provider,data})=>{
//             console.log(data)

//         }}

//             //   setTimeout(()=>{
//             //     toast({
//             //     title:"Register with google done",
//             //     position: "top-right",
//             //     isClosable: true,
//             //     status: 'success'
//             //   })
//             // //   },2500)
          
//           onReject={(err) => {
//             console.log(err);
//           }}
//         >
//           {/* <GoogleLoginButton style={{width:"300px",marginLeft:"150px",marginTop:"50px"}}  /> */}
//           <button
//             type="button"
//             data-te-ripple-init
//             data-te-ripple-color="light"
//             class="mx-1 h-10 w-10 rounded-full bg-primary uppercase leading-normal text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] inline-block"
//           >
//             {/* <!-- Google --> */}
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="35"
//               height="24"
//               fill="currentColor"
//               class="bi bi-google"
//               viewBox="0 0 16 16"
//             >
//               <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
//             </svg>
//           </button>
//         </LoginSocialFacebook>

//         {/* <button onClick={addGoogle}>google sign in</button> */}
//       </>
//     );
// }

// export default Facebook

import { FacebookProvider, Like,LoginButton } from 'react-facebook';


 function Facebook() {
    const handleResponse = (data) => {
        console.log(data,"data"); // Handle the response from Facebook registration
      };
      
    return (
    <>
    <button>
      <FacebookProvider appId="2084915091853699">
      <LoginButton
        scope="jeevanaloor500@gmail.com"
        onCompleted={handleResponse}
        onError={console.log}
      >
        Register with Facebook
      </LoginButton>
        {/* <Like href="http://www.facebook.com" colorScheme="dark" showFaces share /> */}
      </FacebookProvider></button>
      </>
    );
  }

  export default Facebook